import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-static-progress-bar',
  templateUrl: './static-progress-bar.component.html',
  styleUrls: ['./static-progress-bar.component.scss']
})
export class StaticProgressBarComponent {
  @Input() elapsed!: number;
  @Input() total!: number;
  @Input() units!: string;

  getPercentage() {
    return (this.elapsed / this.total) * 100
  }


  getColor() {
    if (this.getPercentage() < 40) {
      return 'danger';
    }
    if (this.getPercentage() < 60) {
      return 'amber';
    }
    return 'green';

  }
}
